let filters = document.getElementsByClassName('js-filter');
let i;

for (i = 0; i < filters.length; i++) {
    filters[i].addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('open');
        var panel = this.nextElementSibling;
        if (panel.style.display === '' || panel.style.display === 'none') {
            panel.style.display = 'block';
        } else {
            panel.style.display = 'none';
        }
    });
}

let filterHolder = document.querySelector('.filter-holder');
let filtersOpen = document.querySelector('.js-open-filters');
let filtersClose = document.querySelectorAll('.js-close-filters');

filtersOpen.addEventListener('click', openFilters);

for (let i = 0; i < filtersClose.length; i++) {
    filtersClose[i].addEventListener('click', closeFilters);
}

function openFilters() {
    filterHolder.classList.add('open');
    document.body.classList.add('filters-open');
}

function closeFilters() {
    filterHolder.classList.remove('open');
    document.body.classList.remove('filters-open');
}